export default class BrochureCpnt {
    constructor() {}

    static checkBrochures() {
        const trigger = '[data-trigger="add-brochure-send"]'

        if ($(trigger).length > 0) {
            const $listSelection = $('[data-element="brochures-selection"]')
            const $listAll = $('[data-element="brochures-list"]')

            $(document).on('change', trigger, function () {
                const $this = $(this)
                let datas = []
                const selection = $.data(document, 'selection')
                let itemSelectionIndex = -1
                const itemId = $this.closest('[data-brochure-id]').data('brochure-id')

                const item = {
                    id: itemId,
                    title: $this.closest('[data-element]').attr('data-title').replace(/\n/g, ''),
                }

                if (selection) {
                    datas = selection
                }

                $.each(datas, function (index) {
                    if (this.id == itemId) {
                        itemSelectionIndex = index
                    }
                })

                if (itemSelectionIndex > -1) {
                    datas.splice(itemSelectionIndex, 1)
                    $listSelection.find('[data-brochure-id="' + itemId + '"]').remove()
                    $listAll.find('[data-brochure-id="' + itemId + '"] input').removeAttr('checked')
                } else {
                    // Add item
                    datas.push(item)
                    $(`[data-brochure-id=${item.id}]`)
                        .clone()
                        .appendTo('[data-element="brochures-selection"]')
                        .find('[data-label]')
                        .text(item.title)
                }

                if (datas.length > 0) {
                    $listSelection.find('[data-element="brochures-selection-empty"]').hide()
                } else {
                    $listSelection.find('[data-element="brochures-selection-empty"]').fadeIn()
                }

                $.data(document, 'selection', datas)
            })
        }
    }

    static sendBrochuresCheck() {
        const input_hidden = $('input#field_form-input-brochures'),
            trigger = '[data-trigger="add-brochure-send"]'

        $(document).on('change', trigger, () => {
            const selection = $.data(document, 'selection')
            let input_value = ''

            $.each(selection, function () {
                input_value += '- ' + this.title + '\n'
            })

            input_hidden.val(input_value)
        })
    }
}
